import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { BackgroundView } from '../background';
import { WidgetsContext } from '../core';
import { getBoxShadow } from '../../../services/cssHelper.service';

import styles from './section.module.scss';

const SectionWidgetComponent = ({ className, style, widgetProps, breakpoint, children, ...rest }) => {

  const context = React.useContext(WidgetsContext);
  const storyboardType = _.get(context, 'storyboard.type');

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false) && storyboardType !== 'INTERACTIVE_CONTENT';
  const background = _.get(widgetProps, 'properties.desktop.background');

  const columns = _.size(children);
  const columnSpacing = _.get(widgetProps, `properties.${breakpoint}.columnSpacing`, 0);
  const adjustedColumnSpacing = columnSpacing * ((columns - 1) / columns);

  var widgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint)
  }

  return (
    <div id={id}
      className={cx(className, styles.section, 'cs_section', {
        [styles.stretched]: stretched,
        [styles.mobile]: breakpoint === 'mobile'
      })}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView background={background} breakpoint={breakpoint} />
      {React.Children.map(children,
        child => {
          return (
            React.cloneElement(child, {
              columnGap: adjustedColumnSpacing
            }, null)
          );
        })
      }
    </div>
  );
};

function getStyles(widgetProps, breakpoint) {
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const margin = _.get(widgetProps, 'properties.desktop.margin', 0);
  const padding = _.get(widgetProps, `properties.${breakpoint}.padding`, 0);
  const columnSpacing = _.get(widgetProps, `properties.${breakpoint}.columnSpacing`, 0);

  var widgetStyles = {
    paddingTop: `${padding}px`,
    paddingBottom: `${padding}px`
  }

  if (breakpoint === 'desktop') {
    widgetStyles = {
      ...widgetStyles,
      width: `1200px`,
      columnGap: `${columnSpacing}px`,
      paddingLeft: `${padding}px`,
      paddingRight: `${padding}px`
    }

    if (stretched) {
      widgetStyles = {
        ...widgetStyles,
        marginLeft: margin,
        width: `calc(100% - 2 * ${margin}px)`,
        left: `calc((100% - 2 * ${margin}px))/2)`
      }
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      rowGap: `${columnSpacing}px`,
    }
  }

  //DropShadow
  const shadow = _.get(widgetProps, `properties.desktop.shadow`, {});
  const shadowStyle = getBoxShadow(shadow);
  widgetStyles = {
    ...widgetStyles,
    ...shadowStyle
  }

  return widgetStyles;
}

const sectionWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const SectionWidget = React.memo(SectionWidgetComponent, sectionWidgetEquals);

